import {LEVEL_INFO, GAME, GAMEOVER, GAMEINTRO} from "./constants/RouteConstants";
import {Home, Game, GameOver, GameIntro} from "./views";

export default [
  {
    path: LEVEL_INFO,
    exact: true,
    component: Home,
  },
  {
    path: GAME,
    exact: true,
    component: Game,
  },
  {
    path: GAMEOVER,
    exact: true,
    component: GameOver,
  },
  {
    path: "/",
    exact: true,
    component: GameIntro,
  },
];
